import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rockrms': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM405.4 427.5H315.4L203.4 296.2C185.5 275.8 199.5 240.1 230 240.1H305.3L220.7 140.8 136.4 239.7H46.4L193.5 67.2C207.9 48.8 234.8 49.9 248 67.2L405.7 252.3C424.7 275.1 407.7 309.5 378.1 308.4 377.5 308.4 303.9 308.6 303.9 308.6L405.4 427.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/rockrms.js
// module id = cnLH
// module chunks = 144